import { ActivatedRoute, Router } from '@angular/router';
import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { from } from 'rxjs';

import { EvaluationNavSections } from 'src/app/core/enums/evaluation-nav-categories';
import { Gender } from 'src/app/core/enums/gender';
import { PairingService } from 'src/app/core/services/pairing.service';
import { Patient } from 'src/app/core/entities/patient.entity';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css'],
})
export class DetailComponent implements OnInit {
  @ViewChild('navWrapper') navWrapper: ElementRef;
  public gender = Gender;
  public showProfile = false;
  public loading = true;
  public navSectionActive = EvaluationNavSections.overview;
  public evaluationNavSections = EvaluationNavSections;
  public navActive = 'overview';
  public patientProfile: Patient = new Patient();

  constructor(
    private route: ActivatedRoute,
    private pairingService: PairingService,
    private router: Router
  ) {}

  ngOnInit(): void {
    from(this.pairingService.getMyPatient(this.route.snapshot.params['uuid']))
      .pipe(finalize(() => (this.loading = false)))
      .subscribe((res) => {
        this.patientProfile = res;
      });
  }

  /**
   * Changes navigation item
   * @param event nav event
   */
  changeNavActive(event: any): void {
    //If the function is called from the navBar, the id of the active tab 
    //is assigned to navActive, otherwise, the function is called from the "See more" button
    //of the Surveys, and the evaluation code is assigned to navActive directly
    this.navActive = typeof event === 'object' && event !== null ? event.nextId : event;
    switch (this.navActive) {
      case 'perimeter':
      case 'endurance':
      case 'vision':
      case 'dexterity':
      case 'cognition':
        this.navSectionActive = this.evaluationNavSections.tests;
        break;
      case 'blcs':
      case 'bwcs':
      case 'mfis5':
      case 'phq8':
      case 'sf36':
      case 'ps':
        this.navSectionActive = this.evaluationNavSections.surveys;
        break;
      default:
        this.navSectionActive = this.evaluationNavSections.overview;
        break;
    }
  }

  back() {
    this.router.navigate(['list'], { relativeTo: this.route });
  }

  switchSurveysTab(evaluationCode: string) {
    this.changeNavActive(evaluationCode);
  }
}
